import { apm } from "@elastic/apm-rum";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import {
  AxisPanel as AxisPanelIcon,
  AxisPanelFilled as AxisPanelFilledIcon,
} from "shared/common/utils/icons/icons";
import PopoverBox from "shared/common/utils/popover/PopoverBox";
import AxisPanel from "./AxisPanel";

interface props {}
export default function AxisVisibilityPanelButton({}: props) {
  const { t } = useTranslation();

  const viewer = defaultStore((state) => state.viewer);
  const layerConfiguration = defaultStore((state) => state.layerConfiguration);
  const showAxisscale = defaultStore((state) => state.showAxisscale);

  const changeAxisControlPopover = sidebarStore(
    (state) => state.changeAxisControlPopover
  );
  const axisControlPopover = sidebarStore((state) => state.axisControlPopover);
  const closeAllToolPopover = sidebarStore(
    (state) => state.closeAllToolPopover
  );

  const handleClickTopic = () => {
    closeAllToolPopover();
    changeAxisControlPopover(!axisControlPopover);
  };

  const handleCloseTopic = () => {
    closeAllToolPopover();
  };

  return (
    <>
      <Tooltip
        title={t("axis_panel.title")}
        placement="right"
        enterDelay={400}
        classes={{
          tooltip: "infra3d-buttonDescription",
        }}
      >
        <IconButton
          sx={{
            display: showAxisscale ? "inline-flex" : "none",
            width: "40px",
            mx: "auto",
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          classes={{
            root: axisControlPopover
              ? "infra3d-iconButtonRippleActive"
              : "infra3d-iconButtonRipple",
          }}
          onClick={() =>
            monitor(apm, "change-status-layertree | Toolbar", handleClickTopic)
          }
          disableRipple={true}
          id="infra3d-axisVisibilityPanelButton"
        >
          {!axisControlPopover && <AxisPanelIcon />}
          {axisControlPopover && <AxisPanelFilledIcon />}
        </IconButton>
      </Tooltip>
      <PopoverBox visible={axisControlPopover}>
        {viewer !== undefined &&
          layerConfiguration !== undefined &&
          axisControlPopover && <AxisPanel handleClose={handleCloseTopic} />}
      </PopoverBox>
    </>
  );
}
